/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Problem,
  WorkspaceAnalyticsResponse,
} from '../models/index';
import {
    ProblemFromJSON,
    ProblemToJSON,
    WorkspaceAnalyticsResponseFromJSON,
    WorkspaceAnalyticsResponseToJSON,
} from '../models/index';

/**
 * AnalyticsApi - interface
 * 
 * @export
 * @interface AnalyticsApiInterface
 */
export interface AnalyticsApiInterface {
    /**
     * Returns comprehensive analytics for the authenticated user\'s workspace. - For MEMBER role: Returns only data for claims they created - For ADMIN/OWNER roles: Returns all company data 
     * @summary Get workspace analytics
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AnalyticsApiInterface
     */
    getWorkspaceAnalyticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceAnalyticsResponse>>;

    /**
     * Returns comprehensive analytics for the authenticated user\'s workspace. - For MEMBER role: Returns only data for claims they created - For ADMIN/OWNER roles: Returns all company data 
     * Get workspace analytics
     */
    getWorkspaceAnalytics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceAnalyticsResponse>;

}

/**
 * 
 */
export class AnalyticsApi extends runtime.BaseAPI implements AnalyticsApiInterface {

    /**
     * Returns comprehensive analytics for the authenticated user\'s workspace. - For MEMBER role: Returns only data for claims they created - For ADMIN/OWNER roles: Returns all company data 
     * Get workspace analytics
     */
    async getWorkspaceAnalyticsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceAnalyticsResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/analytics/workspace`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceAnalyticsResponseFromJSON(jsonValue));
    }

    /**
     * Returns comprehensive analytics for the authenticated user\'s workspace. - For MEMBER role: Returns only data for claims they created - For ADMIN/OWNER roles: Returns all company data 
     * Get workspace analytics
     */
    async getWorkspaceAnalytics(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceAnalyticsResponse> {
        const response = await this.getWorkspaceAnalyticsRaw(initOverrides);
        return await response.value();
    }

}
